import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
